<template>
  <div class="clearfix base-info">
    <!-- 基本信息 -->
    <div class="bg1 fl">
      <h1>基本信息</h1>
      <div class="content clearfix">
        <div class="photos-people fl">
          <img
            :src="userBaseInfo.userLogo ? userBaseInfo.userLogo : defaultUrl"
            alt=""
          >
        </div>
        <div class="info fl">
          <h2><span>姓名：</span>{{userBaseInfo.userName ||""}} </h2>
          <h2><span>性别：</span>{{userBaseInfo.userSex ||""}} </h2>
          <h2><span>学科：</span>{{JSON.parse(userBaseInfo.teacherArchivesDTO.schoolDiscipline||"[]").toString()}}</h2>
          <h2><span>师训号：</span>{{userBaseInfo.teacherArchivesDTO.teacherNum || ""}}</h2>
          <h2><span>职称：</span>{{userBaseInfo.teacherArchivesDTO.academicTitlesDesc || ""}}</h2>
          <h2><span>教龄：</span>{{userBaseInfo.teacherArchivesDTO.teachingAge ? (userBaseInfo.teacherArchivesDTO.teachingAge+"年") : ""}}</h2>
          <h2><span>学历：</span>{{userBaseInfo.teacherArchivesDTO.educationDesc || ""}} </h2>
          <h2><span>毕业院校：</span>{{userBaseInfo.teacherArchivesDTO.graduateSchool || ""}} </h2>
        </div>
      </div>

    </div>
    <!-- 教师综合能力 -->
    <div class="bg2 fl">
      <h1>教师综合能力</h1>
      <div
        class="content"
        v-if="!scoreList.length"
      >
        <img :src="blankScoreUrl">
      </div>
      <div
        class="content"
        v-else
      >
        <div class="tu">
          <div
            style="width:100%;height:100%"
            class="chart-class"
            ref="ability"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    baseInfo: "",
    baseInfoScore: "",
    scoreList: "",
  },
  computed: {
    userBaseInfo() {
      return this.baseInfo.find((item) => item.name == "教师基本信息").data;
    },
    // dataLegend(){
    //   return this.scoreList.map((item) => item.moduleType);
    // },
  },
  data() {
    return {
      blankScoreUrl: require(`@/assets/image/echarts/noScore.png`),
      defaultUrl: require(`@/assets/image/other/headMan.png`),
    };
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      let dataEc = {
        //dataLegend: this.dataLegend,
        dataList: this.scoreList,
        color: [
          "#1890FF",
          "#F04864",
          "#FACC14",
          "#2FC25B",
          "#A3FF00",
          "#975FE4",
          "red",
          "blue",
          "#FF5400",
          "#FF77D7",
        ],
      };
      let option = {
        color: dataEc.color,
        title: [
          {
            text: "总分",
            x: "34%",
            y: "40%",
            textAlign: "center",
            textStyle: {
              fontSize: "15",
              fontWeight: "100",
              color: "#000",
              textAlign: "center",
            },
          },
          {
            text: this.baseInfoScore + "分",
            x: "34%",
            y: "48%",
            textAlign: "center",
            textStyle: {
              fontSize: "24",
              fontWeight: "400",
              color: "#36CB8C",
              textAlign: "center",
            },
          },
        ],
        tooltip: {
          trigger: "item",
          formatter: "教师综合能力：<br/>{b}: {c} ({d}%)",
        },
        legend: {
          x: "left",
          left: "75%",
          top: "17%",
          textStyle: {
            color: "rgba(0, 0, 0, 0.45)",
            fontSize: 13,
          },
          orient: "vertical",
          //原点
          icon: "circle",
          //修改icon图形大小
          itemHeight: 7,
          data: dataEc.dataLegend,
        },
        series: [
          {
            type: "pie",
            radius: ["89.5%", "90%"],
            center: ["35%", "50%"],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            name: "",
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#36cb8c",
                  },
                },
              },
            ],
          },
          {
            name: "Line 1",
            type: "pie",
            clockWise: true,
            radius: ["30%", "80%"],
            center: ["35%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
              },
            },
            //触摸显示中间的标题
            emphasis: {
              label: {
                show: false,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            hoverAnimation: false,
            data: dataEc.dataList,
          },
        ],
      };
      if(this.$refs.ability){
        let myChart = this.$echarts.init(this.$refs.ability);
        myChart.setOption(option);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.base-info {
  box-sizing: border-box;
  .bg1 {
    box-sizing: border-box;
    width: 580px;
    height: 439px;
    background: url("../../../assets/image/echarts/bg1.png") no-repeat;
    margin-right: 20px;
    margin-bottom: 20px;
    h1 {
      box-sizing: border-box;
      height: 54px;
      line-height: 54px;
      font-size: 16px;
      font-weight: 500;
      padding-left: 35px;
    }
    .content {
      box-sizing: border-box;
      padding: 45px 0px 45px 60px;
      .photos-people {
        box-sizing: border-box;
        border: 2px dashed @theme-color;
        padding: 5px;
        border-radius: 10px;
        width: 228px;
        height: 300px;
        img {
          box-sizing: border-box;
          border-radius: 10px;
          width: 216px;
          height: 288px;
        }
      }
      .info {
        box-sizing: border-box;
        margin-left: 30px;
        width: 50%;
        height: 300px;
        padding-top: 10px;
        h2 {
          font-size: 16px;
          font-weight: 500;
          color: #000 0.8;
          height: 35px;
          line-height: 35px;
          span {
            font-size: 14px;
            color: @hui-color;
          }
        }
      }
    }
  }
  .bg2 {
    width: 580px;
    height: 439px;
    background: url("../../../assets/image/echarts/bg1.png") no-repeat;
    margin-right: 20px;
    margin-bottom: 20px;
    h1 {
      height: 54px;
      line-height: 54px;
      font-size: 16px;
      font-weight: 500;
      padding-left: 35px;
    }
    .content {
      box-sizing: border-box;
      padding: 30px 0px 20px 40px;
      height: 380px;
      box-sizing: border-box;
      img{
        width: 100%;
        height: 100%;
      }
      .tu {
        height: 100%;
        width: 100%;
      }
    }
  }
}
</style>
